<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="disabled ? '详情' : rtRoute.pkid ? '编辑' : '新建'"
    class="adaptationModal"
    width="800px"
    @close="$reset('form')"
  >
    <el-form
      ref="form"
      :disabled="disabled"
      v-loading="contentLoading"
      :model="rtRoute"
      :rules="ruleValidate"
      class="form"
      label-width="80px"
    >
      <div>
        <div class="editTitle">基本信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="路线编号" prop="routeNo">
              <el-input v-model="rtRoute.routeNo" placeholder="请输入工艺路线编号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="路线名称" prop="routingName">
              <el-input v-model="rtRoute.routingName" placeholder="请输入工艺路线名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="路线状态" prop="status">
              <el-select v-model="rtRoute.status" clearable placeholder="请选择工艺路线状态">
                <el-option label="待确认" :value="10" />
                <el-option label="已确认" :value="20" />
                <el-option label="已作废" :value="90" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input v-model="rtRoute.note" type="textarea" autosize placeholder="请输入" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div>
        <div class="editTitle">工序</div>
        <el-button type="primary" style="margin-bottom: 5px" @click="$refs.selectProcedure.open()"> 添加 </el-button>
        <el-table class="dragTable" :data="rtRoute.rtRouteProcessVoList" border row-key="processIndex">
          <el-table-column align="center" label="序号" type="index" width="55" />
          <el-table-column prop="processNo" align="center" label="工序编号" width="100" />
          <el-table-column prop="processTypeName" align="left" label="工序类型" width="120" />
          <el-table-column prop="processName" align="left" label="工序名称" />
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="danger" @click="deleteProcedure(scope.$index)"> 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="editTitle" style="margin-top: 10px">生产中心</div>
        <el-button type="primary" style="margin-bottom: 5px" @click="$refs.selectWorkCenter.open()"> 添加 </el-button>
        <el-table :data="rtRoute.rtRouteWorkCenterVoList" border>
          <el-table-column prop="workCenterNo" align="center" label="编号" width="100" />
          <el-table-column prop="workCenterName" align="left" label="名称" />
          <el-table-column prop="isDefault" align="center" label="默认" width="130">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.isDefault" @change="radioChange(scope.row)">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="danger" style="border-radius: 2px" @click="deleteWorkCenter(scope.$index)"> 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" v-if="!disabled" @click="handleSubmit">确定</el-button>
    </span>
    <!-- 选择工序 -->
    <procedure-select ref="selectProcedure" @select="selectProcedure" />
    <!-- 选择生产中心 -->
    <work-center-select ref="selectWorkCenter" @select="selectWorkCenter" />
  </el-dialog>
</template>

<script>
import ProcedureSelect from "@/views/information/Procedure/ProcedureSelect";
import WorkCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
import Sortable from "sortablejs";
export default {
  components: {
    ProcedureSelect,
    WorkCenterSelect,
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      contentLoading: false,
      submitLoading: false,
      rtRoute: {
        pkid: 0,
        routingName: "",
        note: "",
        status: "",
        rtRouteWorkCenterVoList: [],
        rtRouteProcessVoList: [],
      },
      ruleValidate: {
        routeNo: { required: true, message: "请输入工艺路线编号", trigger: "blur" },
        routingName: { required: true, message: "请输入工艺路线名称", trigger: "blur" },
        status: { required: true, message: "请选择工艺路线状态", trigger: "change" },
      },
    };
  },
  methods: {
    open(row, mark) {
      this.dialogVisible = true;
      this.disabled = !!mark;
      this.$nextTick(() => {
        this.rowDrop();
      });
      if (row) {
        this.getData(row.pkid);
      }
    },

    // 根据路线id查询详细信息
    getData(id) {
      this.contentLoading = true;
      this.$http
        .get("basic", `rtRoutes/${id}`)
        .then((resp) => {
          if (resp.success) {
            this.rtRoute = resp.data;
            this.contentLoading = false;
          }
        })
        .catch(() => {
          this.contentLoading = false;
        });
    },

    selectProcedure(row) {
      const newArr = this.rtRoute.rtRouteProcessVoList.sort((a, b) => b.processIndex - a.processIndex);
      const procddureItem = {
        processId: row.pkid,
        processIndex: newArr[0] ? newArr[0].processIndex + 1 : 1,
        processNo: row.processNo,
        processName: row.processName,
        processTypeName: row.processTypeName,
      };
      this.rtRoute.rtRouteProcessVoList.push(procddureItem);
    },

    deleteProcedure(index) {
      this.rtRoute.rtRouteProcessVoList.splice(index, 1);
    },

    rowDrop() {
      const tbody = document.querySelector(".dragTable .el-table__body-wrapper tbody");
      const that = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = that.rtRoute.rtRouteProcessVoList.splice(oldIndex, 1)[0];
          that.rtRoute.rtRouteProcessVoList.splice(newIndex, 0, currRow);
        },
      });
    },

    selectWorkCenter(row) {
      const arr = this.rtRoute.rtRouteWorkCenterVoList.filter((item) => item.workCenterNo === row.workCenterNo);
      if (arr.length) {
        this.$confirm("生产中心：" + row.workCenterName + "已存在，请勿重复添加", "错误", {
          type: "error",
          showCancelButton: false,
        });
        return;
      }
      const workCenterItem = {
        workCenterId: row.pkId,
        workCenterNo: row.workCenterNo,
        workCenterName: row.workCenterName,
        isDefault: false,
      };
      this.rtRoute.rtRouteWorkCenterVoList.push(workCenterItem);
    },

    deleteWorkCenter(index) {
      this.rtRoute.rtRouteWorkCenterVoList.splice(index, 1);
    },

    radioChange(row) {
      this.rtRoute.rtRouteWorkCenterVoList.forEach((item, i) => {
        if (item.workCenterId !== row.workCenterId) {
          item.isDefault = false;
        }
      });
    },

    // 编辑、新建
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.rtRoute.rtRouteProcessVoList.length) {
            this.$confirm("请选择工序", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          if (!this.rtRoute.rtRouteWorkCenterVoList.length) {
            this.$confirm("请选择生产中心", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          if (!this.rtRoute.rtRouteWorkCenterVoList.find(item => item.isDefault)) {
            this.$confirm("请设置默认生产中心", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          this.rtRoute.rtRouteProcessVoList.forEach((item, index) => {
            item.processIndex = index + 1;
          });
          this.submitLoading = true;
          this.$http
            .save("basic", "rtRoutes", this.rtRoute)
            .then((resp) => {
              if (resp.success) {
                if (this.rtRoute.pkid) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 5px;
}
</style>
